import React, { Component } from "react";
import Map from "./Map";
import './style.css';

class App extends Component {
    render() {
        return (
            <div>
                <Map />
            </div>
        );
    }
}

export default App;
